// @flow strict
/** Generates a unique ID */
const generateUID = () => `${Math.random()}`.substr(2);
export default generateUID;
